var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCoin = function SvgCoin(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E02020",
    d: "M4.668 2.796c2.578 0 4.667-.626 4.667-1.398C9.335.626 7.245 0 4.668 0 2.09 0 .001.626.001 1.398c0 .772 2.09 1.398 4.667 1.398z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9E9E",
    d: "M4.668 5.942c2.577 0 4.667-.626 4.667-1.398V2.96c-1.469.826-3.997.886-4.667.886-.67 0-3.198-.06-4.667-.886v1.585c0 .772 2.089 1.398 4.667 1.398z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E02020",
    d: "M6.334 13.191v2.09c-.513.063-1.08.098-1.667.098-2.58 0-4.667-.63-4.667-1.398v-1.586c1.467.825 4 .888 4.667.888.287 0 .921-.015 1.667-.091z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9E9E",
    d: "M6.408 10.039c-.02.063-.033.14-.047.21l-.027-.022v1.909c-.513.063-1.08.097-1.667.097-2.58 0-4.667-.629-4.667-1.397V9.249c1.467.825 4 .888 4.667.888.294 0 .961-.014 1.741-.098z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#E02020",
    d: "M4.668 6.992c-.669 0-3.198-.06-4.667-.887v1.586c0 .772 2.089 1.398 4.667 1.398s4.667-.626 4.667-1.398V6.105c-1.47.826-3.998.887-4.667.887z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9E9E",
    d: "M11.668 11.883c2.393 0 4.333-.625 4.333-1.397s-1.94-1.398-4.333-1.398c-2.393 0-4.333.626-4.333 1.398 0 .772 1.94 1.397 4.333 1.397z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E02020",
    d: "M11.668 14.332c2.393 0 4.333-.626 4.333-1.398v-.886c-1.364.826-3.712.886-4.333.886s-2.969-.06-4.333-.886v.886c-.001.772 1.939 1.398 4.333 1.398z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9E9E",
    d: "M11.668 15.38c-.621 0-2.969-.06-4.333-.886v.886c0 .772 1.94 1.398 4.333 1.398 2.393 0 4.333-.626 4.333-1.398v-.886c-1.364.825-3.712.886-4.333.886z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coin.49c1cd73.svg";
export { ForwardRef as ReactComponent };